import { render } from "./About.vue?vue&type=template&id=24310726"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=24310726&lang=less"
script.render = render

export default script